import { render, staticRenderFns } from "./CertificadoEAnexos.vue?vue&type=template&id=4832a3ab"
import script from "./CertificadoEAnexos.vue?vue&type=script&lang=js"
export * from "./CertificadoEAnexos.vue?vue&type=script&lang=js"
import style0 from "./CertificadoEAnexos.vue?vue&type=style&index=0&id=4832a3ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports